import { useState } from 'react'
import banner from "../../assets/images/banner.jpeg";
import Logo from "../../assets/images/logo.png"
import { FormInput, Button, OTPInput, PasswordChecker } from "components";
import { fetchRequests, postRequest } from 'https/requests';
import { useDispatch } from 'react-redux';
import { show } from 'providers/toastSlice';
import { useNavigate, Link } from 'react-router-dom';
import { STAGING_AUTH } from '../../config/env';

function ForgotPassword() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [phone, setPhone] = useState("");
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [confirm_pass, setConfirm_pass] = useState("");
    const [stepOne, setStepOne] = useState(true);
    const [stepTwo, setStepTwo] = useState(false);
    const [strength, setStrength] = useState(null); 
    const [process, setProcess] = useState(false);
    const [resendProcess, setResendProcess] = useState(false);

    const handleRequest = async(e) => {
        e.preventDefault();
        setProcess(true);

        let data = {
            phone
        }

        let url = `${STAGING_AUTH}/forgot_password`;
        let res = await postRequest(url, data);
        setProcess(false);

        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }

        if(res?.message){
            dispatch(show({
                state : true,
                message : `${res?.message}`,
                type : "success"
            }))
            
            setStepOne(false);
            setStepTwo(true);
        }
    }

    const handleNewPassRequest = async(e) => {
        e.preventDefault();
        setProcess(true);

        if(confirm_pass !== password || confirm_pass === "" || password === ""){
            setProcess(false);
            dispatch(show({
                state : true,
                type : "error",
                message : (confirm_pass !== password) ? `Passwords do not match` : `Password fields can not be empty`,
            }))
            return;
        }

        let data = {
            phone,
            code,
            password
        }
        let headers = {
            "Content-Type" : "application/json"
        }

        let url = `${STAGING_AUTH}/reset_password`;
        let res = await fetchRequests(url, "PUT", headers, {}, data);
        setProcess(false);

        if(res?.err){
            dispatch(show({
                state : true,
                type : "error",
                message : `${res?.err}`
            }))
            return;
        }

        if(res?.message){
            dispatch(show({
                state : true,
                message : `${res?.message}`,
                type : "success"
            }))
        }

        setTimeout(() => {
            navigate("/login")
        }, 2000)
    }

    const handleResendRequest = async(e) => {
        e.preventDefault();
        setResendProcess(true);

        let data = {
            phone
        }

        let res = await postRequest(`${STAGING_AUTH}/resend`, data);
        setResendProcess(false);
        
        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }

        dispatch(show({
            state : true,
            message : `${res?.message}`,
            type : "success"
        }));
    }

    return (
        <div className='min-h-screen w-full flex bg-light-bg dark:bg-dark-page relative overflow-hidden'>
            <div className='pointer-events-none absolute -top-32 -left-32 w-96 h-96 rounded-full bg-light-blue/10 blur-3xl'></div>
            <div className='pointer-events-none absolute -bottom-32 left-1/4 w-96 h-96 rounded-full bg-logo-red/10 blur-3xl'></div>

            <div className='w-full lg:w-1/2 flex flex-col items-center justify-center px-4 py-10 relative z-10'>
                <div className='w-full max-w-md'>
                    <img src={Logo} alt='Cedispay' className='h-11 w-auto mx-auto mb-8' />

                    <div className='bg-white dark:bg-dark-bg rounded-2xl p-8 md:p-10 shadow-xl shadow-slate-200/60 dark:shadow-black/30 border border-slate-100 dark:border-slate-700'>
                        <div className='mb-7 text-center'>
                            <h1 className='text-2xl md:text-3xl font-semibold text-heading dark:text-slate-100 tracking-tight'>
                                {stepOne ? 'Forgot password?' : 'Reset your password'}
                            </h1>
                            <p className='mt-2 text-sm text-slate-500 dark:text-slate-400'>
                                {stepOne ? "Enter your phone number and we'll send you a verification code." : 'Enter the code and choose a new password.'}
                            </p>
                        </div>

                        {stepOne && (
                            <form id="admin-login" onSubmit={handleRequest} className='space-y-5'>
                                <div>
                                    <label htmlFor="phone" className='form-label'>Phone Number</label>
                                    <input type="text" name="phone" id="phone" className='form-input' autoComplete="phone" placeholder='e.g. 0244123456' required value={phone} onChange={(e) => setPhone(e.target.value)} />
                                </div>

                                <Button
                                    btnText={"Send verification code"}
                                    btnClasses={"form-button"}
                                    btnType="submit"
                                    processing={process}
                                />
                            </form>
                        )}

                        {stepTwo && (
                            <div className='space-y-5'>
                                <form id="admin-login" onSubmit={handleNewPassRequest} className='space-y-5'>
                                    <div>
                                        <label htmlFor="otp-0" className="form-label">Verification Code</label>
                                        <OTPInput len={4} setInput={setCode} />
                                    </div>

                                    <FormInput
                                        label='New Password'
                                        type='password'
                                        name='password'
                                        id='password'
                                        placeholder='Choose a strong password'
                                        value={password}
                                        setValue={setPassword}
                                    />

                                    <FormInput
                                        label='Confirm Password'
                                        type='password'
                                        name='confirm_pass'
                                        id='confirm_pass'
                                        placeholder='Re-enter your new password'
                                        value={confirm_pass}
                                        setValue={setConfirm_pass}
                                    />

                                    {password !== "" && (
                                        <div className='-mt-1'>
                                            <PasswordChecker
                                                password={password}
                                                strength={strength}
                                                setStrength={setStrength}
                                            />
                                        </div>
                                    )}

                                    <Button
                                        btnText={"Reset password"}
                                        btnClasses={"form-button"}
                                        btnType="submit"
                                        processing={process}
                                    />
                                </form>

                                <form id='resend-code' onSubmit={handleResendRequest} className='flex items-center justify-center text-sm'>
                                    <span className='text-slate-500 dark:text-slate-400 mr-1'>Didn't get the code?</span>
                                    <Button
                                        btnText={"Resend"}
                                        btnType={"submit"}
                                        btnClasses={"text-light-blue hover:text-dark-blue font-medium"}
                                        processing={resendProcess}
                                    />
                                </form>
                            </div>
                        )}
                    </div>

                    <p className='mt-6 text-center text-sm text-slate-600 dark:text-slate-400'>
                        Remembered your password?{' '}
                        <Link to="/login" className='text-light-blue hover:text-dark-blue font-semibold'>
                            Back to login
                        </Link>
                    </p>
                </div>
            </div>

            <div className='hidden lg:block w-1/2 relative p-4'>
                <div className='relative w-full h-full rounded-3xl overflow-hidden shadow-2xl'>
                    <img src={banner} alt="Cedispay" className='absolute inset-0 w-full h-full object-cover' />
                    <div className='absolute inset-0 bg-gradient-to-t from-dark-blue/80 via-dark-blue/20 to-transparent'></div>
                    <div className='absolute bottom-0 left-0 right-0 p-10 text-white'>
                        <h2 className='text-3xl font-semibold leading-tight max-w-md'>
                            Back on track in a moment.
                        </h2>
                        <p className='mt-3 text-white/80 max-w-md'>
                            We'll help you securely reset your password.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword